import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import Icon from 'components/Icon/Icon';

import styles from './ResetFilter.module.scss';

const ResetFilter = ({ isVisible, onFiltersReset }) => {
  //

  return (
    <div>
      <div className={styles.container}>
        <Button
          disabled={!isVisible}
          className={styles.resetFiltersButton}
          bsStyle="link"
          onClick={() => onFiltersReset()}
        >
          <div style={{ marginTop: '2px', display: 'inline-block' }}>
            Clear your search
          </div>
          <div
            style={{
              position: 'absolute',
              right: '10px',
              display: 'inline-block',
            }}
          >
            <Icon
              color="#aaa"
              icon="&#xe60d;"
              color="#363c6e"
              style={{ verticalAlign: 'sub' }}
              onClick={() => onFiltersReset()}
            />
          </div>
        </Button>
      </div>
    </div>
  );
};

ResetFilter.propTypes = {
  isVisible: PropTypes.bool,
  onFiltersReset: PropTypes.func,
};

ResetFilter.defaultProps = {
  isVisible: false,
  onFiltersReset: () => {},
};

export default ResetFilter;
